import { Modal, Box, Typography, Button } from "@mui/material";
import { usePeriodicModal } from "hooks/usePeriodicModal";

export default function PeriodicAnnouncement() {
  const { open, setOpen } = usePeriodicModal(
    new Date("2025-12-22T00:00:00"),
    new Date("2026-01-06T23:59:59")
  );

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 2,
          boxShadow: 24,
          width: { xs: "90%", sm: 700 }, // optional responsive width
        }}
      >
        <Typography variant="h6">Szanowni Państwo,</Typography>
        <Typography sx={{ mt: 2 }}>
          Dziękujemy za zainteresowanie udziałem w badaniu. Uprzejmie informujemy, że w dniach 22 grudnia – 6 stycznia,
          ze względu na przerwę świąteczną, nie będziemy mieli możliwości bieżącego udzielania odpowiedzi na przesyłane wiadomości.<br/>
          Na wszystkie zgłoszenia i pytania odpowiemy po naszym powrocie.<br/><br/>
          Dziękujemy za wyrozumiałość oraz życzymy Państwu wesołych Świąt i szczęśliwego Nowego Roku.<br/>
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 3 }}
          onClick={() => setOpen(false)}
        >
          Zamknij
        </Button>
      </Box>
    </Modal>
  );
}